export const formatPriceToLocale = (price: number) => {
  return price.toLocaleString('sv');
};